import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "autocomplete-popup__close-button-container q-d-block q-d-lg-none" }

import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'ClosePopupButton',
  setup(__props) {

const popupStore = usePopupStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "autocomplete-popup__close-button",
      class: "autocomplete-popup__close-button",
      type: "button",
      "aria-label": "Wstecz",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(popupStore).hideAutocomplete && _unref(popupStore).hideAutocomplete(...args)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        class: "q-icon q-icon--gmail-back",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          d: "M15.5 5.5 8.5 12l7 6.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.25",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))
  ]))
}
}

})